<template>
  <div style="text-align: center; padding-top: 60px;">
    <h1>Welcome to the Spectator Guides Admin Panel ✅</h1>
    <p>This means Vue 3 + Router + Firebase Hosting are officially working together.</p>
  </div>
</template>

<script>
export default {
  name: 'HelloView' // ✅ This must be multi-word
}
</script>